import {
    LOANFORMAT_ALL_OBJECT,
    LOANFORMAT_EAUDIOBOOK_OBJECT,
    LOANFORMAT_EBOOK_OBJECT,
    LOANFORMAT_EPRESS_OBJECT
} from '../js/shared/loanFormat/constants';

export enum LoanFormat {
    eBooks = 'eBooks',
    eAudiobooks = 'eAudiobooks',

    /**
     * @deprecated
     */
    eMagazines = 'eMagazines',
    /**
     * @deprecated
     */
    eMagazineIssues = 'eMagazineIssues',

    ePress = 'ePress',
    ePressIssues = 'ePressIssues'
}

export enum LoanFormatRequestKey {
    ALL = 'ALL',
    EBOOKS = 'EBOOKS',
    EAUDIOBOOKS = 'EAUDIOBOOKS',
    EMAGAZINES = 'EMAGAZINES'
}

export const parseLoanFormat = (raw: string | null | undefined): LoanFormat | undefined => {
    if (typeof raw !== 'string') {
        return undefined;
    }

    const normalized = raw.trim().toLowerCase();
    const key = Object.keys(LoanFormat).find(key => key.toLowerCase() === normalized);
    return key ? LoanFormat[key] : undefined;
};

export const isLoanFormat = (value: any): value is LoanFormat => {
    return typeof value === 'string' && Object.values(LoanFormat).includes(value as LoanFormat);
};

export const mapLoanFormat = (raw: string | null | undefined): LoanFormat | undefined => {
    const loanFormat = parseLoanFormat(raw);
    if (!loanFormat) {
        return undefined;
    }

    return mapParsedLoanFormat(loanFormat);
};

export const mapParsedLoanFormat = (loanFormat: LoanFormat): LoanFormat => {
    switch (loanFormat) {
        case LoanFormat.eMagazines:
            return LoanFormat.ePress;
        case LoanFormat.eMagazineIssues:
            return LoanFormat.ePressIssues;
        default:
            return loanFormat;
    }
};

export const getLoanFormats = () => [
    LoanFormat.eBooks,
    LoanFormat.eAudiobooks,
    LoanFormat.ePress,
    LoanFormat.ePressIssues
];

export const mapLoanFormatToRequestKey = (loanFormat: LoanFormat) => {
    switch (loanFormat) {
        case LoanFormat.eAudiobooks:
            return LoanFormatRequestKey.EAUDIOBOOKS;
        case LoanFormat.eBooks:
            return LoanFormatRequestKey.EBOOKS;
        case LoanFormat.eMagazines:
        case LoanFormat.eMagazineIssues:
            return LoanFormatRequestKey.EMAGAZINES;
        default:
            return LoanFormatRequestKey.ALL;
    }
};

export const mapLoanFormatToObject = (loanFormat: LoanFormat) => {
    switch (loanFormat) {
        case LoanFormat.eAudiobooks:
            return LOANFORMAT_EAUDIOBOOK_OBJECT;
        case LoanFormat.eBooks:
            return LOANFORMAT_EBOOK_OBJECT;
        case LoanFormat.eMagazines:
        case LoanFormat.eMagazineIssues:
            return LOANFORMAT_EPRESS_OBJECT;
        default:
            return LOANFORMAT_ALL_OBJECT;
    }
};

export const mapLoanFormatToUrl = (loanFormat: LoanFormat) => {
    switch (loanFormat) {
        case LoanFormat.eAudiobooks:
            return 'eaudiobooks';
        case LoanFormat.eBooks:
            return 'ebooks';
        case LoanFormat.eMagazines:
        case LoanFormat.eMagazineIssues:
            return 'emagazines';
        case LoanFormat.ePress:
            return 'epress';
        default:
            return '';
    }
};
